<template>
  <div :class="['m-fixed-buttons']">
    <sq-go-top></sq-go-top>
  </div>
</template>

<script>
import GoTop from './goTop'
export default {
  components: {
    'sq-go-top': GoTop
  },

  data () {
    return {
      show: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// funcButtons.vue?206b18ce